import { createFileRoute } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { useLoadInBrowser } from "@/features/blog/hooks/use-load-in-browser";
import { HelpCentreView, HelpHero } from "@/features/help/modules/help-centre/help-centre";
import { PlatformHead, PlatformPage } from "@/features/platform/components/platform-chrome";
import { pageMeta } from "@/lib/seo";
import { reportApiOutage } from "@/lib/api-outage";
import { m } from "@/paraglide/messages.js";
import { HelpAudience } from "@complete-athlete/enums";

/** The help centre's front page. Read on the server, so search engines get every article's title. */
export const Route = createFileRoute("/(public)/help/")({
  loader: async () => {
    const { data } = await sdk.help.$get.setQueryParams({ audience: HelpAudience.COACH }).send();
    // On the server a failed request hands the page to the browser, which asks again.
    if (!data) reportApiOutage();
    return { centre: data ?? null, crumb: m.help_title() };
  },
  head: () => ({ meta: pageMeta({ title: m.seo_help_title(), description: m.seo_help_description() }) }),
  component: HelpPage,
});

function HelpPage() {
  const { centre } = Route.useLoaderData();
  useLoadInBrowser(centre);

  return (
    <PlatformPage
      head={
        <PlatformHead>
          <HelpHero centre={centre} />
        </PlatformHead>
      }
    >
      {centre ? <HelpCentreView centre={centre} /> : null}
    </PlatformPage>
  );
}
